import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container } from '@michelin/acid-components';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { usePermissions, useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';
import { useProductTour } from 'contexts/ProductTourContext';
import GLOBAL_CONFIG from 'global-variables';
import { useHistory, useParams } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  tourButton: {
    backgroundColor: '#FCE500',
    color: 'rgba(0, 0, 0, 0.87)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#e0cd00',
    },
  },
  requestServiceButton: {
    textTransform: 'none',
    paddingRight: 8,
  },
  requestServiceTooltip: {
    backgroundColor: '#212121',
    fontSize: '1rem',
    whiteSpace: 'pre-line',
  },
  requestServiceTooltipArrow: {
    color: '#212121',
  },
}));

export function HomeModule() {
  const classes = useStyles();
  const { t } = useTranslation();
  const permissions = usePermissions();
  const { startTour } = useProductTour();
  const history = useHistory();
  const { selectedAccount } = useParams<{ selectedAccount: string }>();
  const accountNumber = permissions.location?.customer_number || selectedAccount;
  const fleetName = permissions.location?.customer_dba_name || permissions.location?.customer_name || '';

  return (
    <>
      <PageTitle
        eyebrow={t('Dashboard')}
        title={t('Welcome back, {{fleetName}}', { fleetName })}
        subtitle={t('Your fleet overview')}
        actions={
          <>
            <Button variant="contained" size="small" className={classes.tourButton} onClick={() => startTour()}>
              {t('Platform Tour')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.requestServiceButton}
              onClick={() => history.push(`/${accountNumber}/request-service`, { showComingSoonNotice: true })}
            >
              {t('Request New Service')}
              <Tooltip
                title={String(t('Coming soon in MyPortal'))}
                placement="top"
                arrow
                classes={{ tooltip: classes.requestServiceTooltip, arrow: classes.requestServiceTooltipArrow }}
              >
                <InfoOutlinedIcon
                  aria-label={String(t('Coming soon in MyPortal'))}
                  fontSize="small"
                  style={{ marginLeft: 8 }}
                />
              </Tooltip>
            </Button>
          </>
        }
      />
      <Container height="calc(100dvh - 110px)" spacing={0}>
        <iframe title="LiveTrack" src={GLOBAL_CONFIG.liveTrackUrl} style={{ border: 'none', flex: 1 }} />
      </Container>
    </>
  );
}

